module.exports = __webpack_public_path__ + "static/media/instrucciones.ce8c441a.png";